import React from 'react';
import { ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { useMenusPermitidos } from '../hooks/useMenusPermitidos';

interface ProtectedMenuItemProps {
  tela: string;
  rota: string;
  icon: React.ReactNode;
  label: string;
  drawerOpen?: boolean;
}

const ProtectedMenuItem: React.FC<ProtectedMenuItemProps> = ({ tela, rota, icon, label, drawerOpen = true }) => {
  const { temPermissaoMenu } = useMenusPermitidos();
  const location = useLocation();
  
  // Se não tem acesso à tela, não exibe o item
  if (!temPermissaoMenu(tela)) {
    return null;
  }

  // Estilo para item ativo
  const activeStyle = (path: string) => ({
    backgroundColor: location.pathname === path ? '#EF453D20' : 'transparent',
    '&:hover': {
      backgroundColor: location.pathname === path ? '#EF453D30' : '#EF453D10',
    },
    cursor: 'pointer',
    textDecoration: 'none',
  });

  return (
    <ListItem component={Link} to={rota} sx={activeStyle(rota)}>
      <ListItemIcon>
        {icon}
      </ListItemIcon>
      <ListItemText 
        secondary={label} 
        sx={{ 
          textDecoration: 'none', 
          display: drawerOpen ? 'block' : 'none' 
        }} 
      />
    </ListItem>
  );
};

export default ProtectedMenuItem;